import React, { useState, useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ArabicIcon from '../Common/icons/ArabicIcon';
import EnglishIcon from '../Common/icons/EnglishIcon';
import LanguageSelect from './LanguageSelect';
import { generateRefParam } from '../../utils/languageUtils';
import { getAbsoluteUrl } from '../../utils/urlHelper';

const LanguageSwitcher = (props) => {
  const { sitecoreContext } = props;
  const [link, setLink] = useState('');
  const [refParamValue, setRefParamValue] = useState(null);
  const [hasRefParam, setHasRefParam] = useState(false);
  const absoluteLink = getAbsoluteUrl(link, sitecoreContext);

  const targetLanguage = sitecoreContext.language === 'en' ? 'ar' : 'en';
  let basePath = `/${targetLanguage}${sitecoreContext.itemPath}`;

  if (basePath.endsWith('/')) {
    basePath = basePath.slice(0, -1);
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // const refParam = generateRefParam(targetLanguage);
      setLink(`${basePath}`);

      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has('ref')) {
        setHasRefParam(true);
        setRefParamValue(searchParams.get('ref'));
      }
    }
  }, [sitecoreContext.language, basePath, targetLanguage]);

  const getClassName = () => {
    return props?.mode?.HeaderInDarkColor === '1' || props?.dark
      ? 'fill-black-300 hover:fill-red-500'
      : 'fill-white text-white stroke-white hover:fill-[#C4C7C9]';
  };

  if (typeof document !== 'undefined') {
    document.documentElement.lang = sitecoreContext?.language;
  }

  // If backend data is empty (length 0) AND we have a Ref param, build the list manually
  let languagesList = sitecoreContext.Itemlanguages?.[0] ?? [];

  if (languagesList.length === 0 && hasRefParam && refParamValue && typeof window !== 'undefined') {
    const currentPath = window.location.pathname;
    const currentLang = sitecoreContext.language;

    const getUrlForLang = (lang) => {
      return currentPath.replace(/^\/[a-z]{2}/, `/${lang}`);
    };

    const languagesSet = new Set();

    if (currentLang) {
      languagesSet.add(currentLang);
    }

    if (refParamValue) {
      languagesSet.add(refParamValue);
    }

    languagesSet.add('en');
    languagesSet.add('ar');

    languagesList = Array.from(languagesSet).map(lang => ({
      name: lang,
      url: getUrlForLang(lang)
    }));
  }

  const isStandardLanguage = sitecoreContext.language === 'en' || sitecoreContext.language === 'ar';
  const shouldShowDropdown = (languagesList.length > 2 && (props.homePage || !isStandardLanguage)) || hasRefParam;
  const safeToShowDropdown = shouldShowDropdown && languagesList.length > 0;

  if (safeToShowDropdown) {
    return (
      <LanguageSelect
        options={languagesList}
        currntLanguage={sitecoreContext.language}
        className={getClassName()}
      />
    );
  } else {
    return (
      <a href={absoluteLink}>
        {sitecoreContext.language === 'en' ? (
          <ArabicIcon className={getClassName() + ' 2xl:h-[26px] xl:h-[26px] lg:h-[21px] h-[18px]'} />
        ) : (
          <EnglishIcon className={getClassName() + ' 2xl:h-[26px] xl:h-[26px] lg:h-[21px] h-[18px]'} />
        )}
      </a>
    );
  }
};

export default withSitecoreContext()(LanguageSwitcher);
